// External / cross-domain destinations for the marketing site.
// Domain architecture is kept configurable via env so DNS is never hardcoded:
//   www.sdiptechnologies.com  -> corporate (REACT_APP_CORP_URL)
//   ai.sdiptechnologies.com   -> this product marketing site
//   web.sdiptechnologies.com  -> the SDIP AI web application (REACT_APP_WEBAPP_URL)
// If REACT_APP_WEBAPP_URL is empty, the web app is reached via the internal /app route.

export const CORP_URL = process.env.REACT_APP_CORP_URL || "https://www.sdiptechnologies.com";
export const WEBAPP_URL = process.env.REACT_APP_WEBAPP_URL || ""; // empty => internal /app
export const IOS_URL = process.env.REACT_APP_IOS_URL || "";
export const ANDROID_URL = process.env.REACT_APP_ANDROID_URL || "";

export const webAppIsExternal = !!WEBAPP_URL;
// The intended journey lands users on the real Web App route (/app).
export const webAppHref = WEBAPP_URL ? WEBAPP_URL.replace(/\/$/, "") + "/app" : "/app";
export const storeReady = !!(IOS_URL || ANDROID_URL);
